import React, { useState, useEffect } from 'react';
import { Accordion, Card, OverlayTrigger, Spinner } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as action from '../Store/SystemMasters.action';
import Loader from '../../../Components/Utility/Loader/Loader';
import BtnAdd from '../../../Components/Utility/FilterAction/BtnAdd';
import CardDrag from './CardDrag';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

const btnSave = (isST, t) => {
  return isST ? (
    <Spinner animation="border" />
  ) : (
    <>
      <span className="icon-Save c-button-align f-20 mr-2" /> {t('SAMPLE_TRACK.SAVE')}
    </>
  );
};

function SampleTracking({
  addSampleTracking,
  sTBtnDisable,
  isSTUnique,
  renderTooltipOpenCloseCat3,
  callApi,
  buttonDownST,
  btnCall,
  showST,
  isLoadingST,
  STData,
  handleCheckboxST,
  handleChanged,
  renderCopy,
  renderTooltipActiveInactive,
  activeInactiveClicked,
  renderTooltipDelete,
  handleDelete,
  saveST,
  isST,
  copySampleTracking,
  isUniqueId,
  OpenReArrangeFunction,
  onBrandSelectionChange,
  brandValidationErrors,
}) {
  const [scrollEl, setScrollEl] = useState();
  const [cards, setCards] = useState([]);
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    Users: { logInRights },
    SystemMastersDetails: { brandList = [] },
    UserDetails: { userInfo },
  } = reducer;
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);

  // Load brand data when component mounts
  useEffect(() => {
    const loadBrandData = async () => {
      if (userInfo?.company) {
        try {
          const brandParams = {
            companyURL: userInfo.company,
            page: 1,
            limit: 1000,
            active: true,
          };
          await dispatch(action.getBrandDetails(brandParams));
        } catch (error) {
          console.error('Failed to load brand data:', error);
        }
      }
    };

    loadBrandData();
  }, [userInfo?.company, brandList.length, dispatch]);

  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'samples', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'samples', 'delete');

  useEffect(() => {
    if (Array.isArray(STData) && STData.length) {
      const item = [...STData];
      setCards(item);
    }
  }, [STData]);

  const renderCard = (card, index) => {
    return (
      <CardDrag
        index={index}
        item={card}
        handleCheckboxST={handleCheckboxST}
        handleChanged={handleChanged}
        renderCopy={renderCopy}
        renderTooltipActiveInactive={renderTooltipActiveInactive}
        activeInactiveClicked={activeInactiveClicked}
        renderTooltipDelete={renderTooltipDelete}
        handleDelete={handleDelete}
        copySampleTracking={copySampleTracking}
        isUniqueId={isUniqueId}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
        brandList={brandList}
        onBrandSelectionChange={onBrandSelectionChange}
        brandValidationErrors={brandValidationErrors}
        cardLength={cards?.length || 0}
      />
    );
  };

  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);

  const { t } = useTranslation('common');

  return (
    <Accordion className="mb-4 master-accordian">
      <Card>
        <Card.Header>
          <div className="title-container">
            <p>{t('SAMPLE_TRACK.SAMPLE_TRACKING')}</p>
          </div>
          <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
            {MasterAddEditAccess && (
              <button
                type="button"
                onClick={() => OpenReArrangeFunction('sampleTracking')}
                className="filter-btn filter-button_add"
                disabled={sTBtnDisable || !isSTUnique}
                aria-label={t('SAMPLE_TRACK.REARRANGE')}
                title={t('SAMPLE_TRACK.REARRANGE')}
              >
                <span className="icon-expand" />
              </button>
            )}
            <BtnAdd onBtnClick={addSampleTracking} forDisable={sTBtnDisable || !isSTUnique} addEditAccess={MasterAddEditAccess} />
            <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipOpenCloseCat3}>
              <button onClick={() => callApi('sampleTracking')} type="button">
                {btnCall(buttonDownST)}
              </button>
            </OverlayTrigger>
          </div>
        </Card.Header>
        {showST &&
          (isLoadingST ? (
            <Loader />
          ) : (
            <Card.Body>
              <PerfectScrollbar
                containerRef={(ref) => {
                  setScrollEl(ref);
                }}
              >
                <ul>{cards?.map((sTEle, sTIndex) => renderCard(sTEle, sTIndex))}</ul>
              </PerfectScrollbar>
              <div className="select-container">
                <div className="instruction-container">
                  <span className="important-span">* </span>
                  {t('SAMPLE_TRACK.ADD_SAMPLE_STATUSES')}
                </div>
              </div>
              {MasterAddEditAccess && (
                <div className="section-save">
                  <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                    <button
                      aria-label="Save"
                      className="btn btn-page-filter btn-white"
                      onClick={saveST}
                      disabled={sTBtnDisable || !isSTUnique || isST}
                      type="button"
                    >
                      {btnSave(isST, t)}
                    </button>
                  </CustomTooltip>
                </div>
              )}
            </Card.Body>
          ))}
      </Card>
    </Accordion>
  );
}

export default SampleTracking;
